import { JwtPayload } from "jwt-decode";

export interface IInitPasswordRequest {
    token: string;
    recaptchaToken: string;
};
export interface ILoginRequest {
    username: string;
    password: string;
    recaptchaToken: string;
};
export interface ILoginResponse {
    accessToken: string;
    tokenType: string;
};
export interface IPropositionDetails {
    propositionId: string;
    propositionName: string;
    statusCode: number;
    stateCode: number;
    statusLabel: string;
    stateLabel: string;
    effectiveDate: string;
    signatureDate: Date;
    createdDate: Date;
    subscriptionUrl: string;
    priceId: string;
    priceLabel: string;
    affiliationType: number;
    affiliationTypeLabel: string;
    contact: IContactDetail;
    principalContractId: string;
    principalProductId: string;
    principalProductName: string;
    iban: string;
    bankingHolder: string;
    totalAmount: number;
    beneficiaries: IBeneficiaryAdditionReq[];
    consent?: IConsent;
    configuration: IConfiguration;
    documents: IDocumentDetail[];
    ribHolderConfirm: boolean;
    currentStep: string;
    offerCode: string;
    salaryIndex: number;
    increasedIndex: string;
    mainStep: string;
    hasOldMutual?: boolean|null;
    hasMgpInsurance?: boolean|null;
    oldCompetitor?: IOldCompetitor;
    companyLabel?: string;
    retiredCoveragesInfo?: IRECoveragesInfo;
  }

  export interface IContactDetail {
    contactId?: string;
    administrativeNumber: string;
    firstName: string;
    lastName: string;
    birthDate: string | null;
    email: string;
    memberNumber: string;
    civilityCode: string,
    civilityLabel: string;
    birthName: string;
    birthPlace: string;
    familySituationCode: number,
    familySituationLabel: string;
    nir: string;
    nirKey: string;
    regimeCode: string,
    regimeLabel: string;
    address: string;
    additionalAddress: string;
    buildingName: string;
    city: string;
    postalCode: string;
    lieudit: string;
    countryId: string;
    countryLabel: string;
    hiringDate: Date;
    radiatedDate: Date;
    phoneNumber: string;
    isForeignMobile: boolean | null;
    cspIndex: number;
    cspIndexLabel: string;
    companyIndex: string;
    companyGrade: string;
    attachmentOrganization: string;
    teletranmissionRefuse: string;
    departmentCode: string;
    alsaceMoselleRegime: string;
    retiredDate?: string;
    retirementDate?: string
}  
export  enum coverageLevelEnum {
    ZERO = 1,
    MIN = 2,
    AVERAGE = 3,
    MAX= 4
}

export interface ICoveragesInfo {
    dental: number;
    optical: number;
    excessFees: number;
    hospitalization: number;
}
export interface IRECoveragesInfo {
    nonRefundingPayment: number,
    budget: number
   
}

export interface IUpdatedProposition {
    birthPlace: string;
    protectedAddress: boolean;
    protectedConditions: boolean;
    email: string;
    familySituationCode: string, 
    familySituationLabel ?: string, 
    phoneNumber: string;
    isForeignMobile: boolean;
    teletranmissionRefuse: boolean;
    attachmentOrganization: string;
    iban: string;
    bankingHolder: string;
    consent?: IConsent;
    beneficiaries? : IBeneficiaryAdditionReq[];
    ribHolderConfirm: boolean;
    address: string;
    postalCode: string;
    city: string;
    countryId: string;
    departmentCode: string;
    lieudit: string;
    additionalAddress: string;
    buildingName: string;
    alsaceMoselleRegime: boolean | null;
    offerCode: string;
    salaryIndex: number;
    increasedIndex: string;
    MIOM?: boolean;
    retirementDate?: string;
    birthDate?: string;
    oldCompetitor?: IOldCompetitor;
    oldMutualAddress?: string;
    oldMutualNumber?: string;
    otherMutualName?: string;
    hasOldMutual?: boolean|null;
    hasMgpInsurance?: boolean|null;
    effectiveDate?: string|null;
    coveragesInfo?: IRECoveragesInfo;
    isMgpMember?: boolean;
    civilityCode?: string;
    firstName?: string;
    lastName?:string;
    birthName?:string;
    nir?: string;
    nirKey?: string;
    earliestDate?: boolean;
    pensionServiceCode?: string
}

export interface IConfiguration {
    hasSignature: boolean;
    canBeAddedBeneficiaries: boolean;
    requireIdentityDocument: boolean;
    hasIdentityUploadStep: boolean;
    additionalDocumentTypes: IDocumentType[];
    hasShowPriceAmount: boolean;
    canSubscribeMgpProtect: boolean;
    hasOfferStep: boolean;
    hasSalaryStep: boolean;
    hasPreviousInsuranceTermination: boolean
}

export interface IDocumentDetail {
    documentId: string,
    documentFileName: string,
    documentCategory: string,
    documentTypeCode: string;
    mandatory: boolean;
    name: string;
    state: string;
    status: string;

}

export interface IDocumentType {
    code: string;
    fileName: string;
    label: string;
    category: string;
    hasRequired: boolean;
    displayLabel?: string;
    uploadDocumentType?: uploadDocFncType
}

export interface IChildDetail {
    id?: number;
    birthDate: string;
    hasAlsaceMoselle: boolean;
    hasHandicap: boolean
}

export interface IPartnerDetail {
    birthDate: string;
    hasAlsaceMoselle: boolean;
}

export interface IAdditionalData {
    hasChild: boolean;
    hasPartner: boolean;
    children?: IChildDetail[];
    partnerInfo: IPartnerDetail
}

export enum relationType {
  ASSURE = 'ASSURE',
  CONJOINT = 'CONJOINT',
  CONCUBIN = 'CONCUBIN',
  CHILD = 'CHILD',
}

export enum uploadDocFncType {
    uploadFamilyDocument = 'uploadFamilyDocument',
    uploadSocialSecurity = 'uploadSocialSecurity',
    uploadRetirementDocument = 'uploadRetirementDocument'
  
}

export type IBeneficiaryAdditionReq = {
  relationType: relationType | null,
  isConfirmed: boolean,
  contact: {
    contactId: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    civilityCode: string,
    civilityLabel?: string,
    nir: string,
    nirKey: string,
    regimeCode: string,
    attachmentOrganization: string,
    alsaceMoselleRegime: boolean,
    hasHandicap: boolean
  }
}

export interface IExtractedBeneficiary {
    isPrincipalBeneficiary: boolean;
    socialSecurityNumber: string;
    socialSecurityOrg: string;
    regimeSocial: string;
    fullName: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    nir: string;
    nirKey: string;
    regimeLabel: string |null;
    regimeCode: string | null;
    startDate: string;
    expirationDate: string;
    civilityCode: string;
    civilityLabel: string;
    isValidSecurityNumber: boolean;
    isValidSocialSecurityOrg: boolean;
    isValidNir: boolean;
}
export interface IOldCompetitor {
    code?: string;
    siren?: string;
    name?: string;
    address?: string;
    additionalAddress?: string;
    buildingName?: string;
    city?: string;
    postalCode?: string;
    contractNumbers?: string[],
    isOtherName?: boolean,
    otherName?: string;
}

export interface IUploadedDocument<T> {
    id: string,
    fileName: string,
    name: string,
    extractedData: T;
}

export interface IExtractedSecurityInfo {
    isValid: boolean;
    isValidDuration: boolean;
    isAttestationSecu: boolean;
    beneficiaries: IExtractedBeneficiary[];
}

export interface IExtractedRibInfo {
  isValid: boolean;
  iban: string;
  bicCode: string;
  accountOwner: string;
}

export interface IChangedContact {
    birthPlace: string;
    email: string;
    familySituationCode: string,    
    phoneNumber: string;
}

export interface IConsent {
    commercialEmailAccept: boolean;
    commercialSmsAccept: boolean;
    commercialTelephoneAccept: boolean;
    showCommercialMgpChoice?: boolean;
    commercialPartnerAccept: boolean;   
}

export interface IBeneficiaryInfo {
    productId: string;
    contactId: string;
    contractId: string;
    contact: IBeneficiaryAdditionReq
}

export interface IPreContractDocument {
  key: string,
  name: string,
  fileName: string,
  type: string,
  accepted?: boolean
}

export interface IApiErrors {
    code: string;
    message: string;
    errors: string[];
}

export interface IJwtToken {
    propositionId: string;
    accessToken: string;
    refreshToken: string;
    expiration: number;
    roles: string;
    validateDob?: boolean
}

export interface MgpJwtPayload extends JwtPayload {
    roles: string;
    validateDob: boolean
}

export interface INomenclature {
    id: string;
    options: IOption[];
}

export interface IOption {
    code: string;
    label: string;
}

export interface IInfoStep {
    code: string;
    category: 'DEMANDE' |'PERSONAL' | 'SIGNATURE' | 'BENEFICIARY' | 'RECAP' | 'GUARANTY' | "SITUATION" | "BESOIN" | "INFO";
    path:  string;
    label: string;
    state: 'INACTIVE' | 'ACTIVE' | 'SAVED';
    percentage: string;
    menuHide?: boolean;
    reviewMode?: boolean
}

export interface IUploadedDoc {
    id: string;
    name: string;
    fileName?: string;
    fileType?: string
}

export interface ISignContract {
    sessionUid: string;
    smsCode: string;
}

export interface IEventRequest {
    eventId: string;
    message: string;
}

export interface IAdresseSearch {
    type: string;
    version: string;
    features: IAdresseSearchFeature[];

}

export interface IAdresseSearchFeature {
    type: string;
    version: string;
    properties: IAdresseSearchFeatureProps;
}


export interface IAdresseSearchFeatureProps {
    label: string;
    name: string;
    housenumber: string;
    street: string;
    postcode: string;
    city: string;
    
}

export interface IDqeAdresse {
    [key: string]: IDqeAdresseData
}

export interface IDqeAdresseData {
    countryCode: string;
    city: string;
    postalCode: string;
    streetName: string;
    streetNumber: string; 
}

export interface IValidEmail {
    email: string;
    errorCode: string;
    valid: boolean;
}

export interface IAdditionalOption {
    type: string;
    name: string;
    amount: number;
    id: string;
}

export interface IModificationDataAfterSignature {
    attachmentOrganization: string;
    iban: string;
    beneficiaries: IBeneficiaryAdditionReq[]
}

export interface IUpdatedStepRequest {
    stepName: string;
    cartData: string;
}

export interface IPropositionCart {
    data: string;
}

export interface IGarantie {
    code: string;
    titre: string;
    subTitre: string;
    garantieRecommandee: boolean;
    totaleMensualite: number;
    partSalarieMensualite: number;
    partEmployeurMensualite: number;
    santeclairInclus: boolean;
    garantieBase: boolean;
    servicesInclusTexte: string;
    couvertures: IGarantieCouverture[];
}

export interface IGarantieCouverture {
    couvertureTitre: string;
    couvertureChiffre: number;
    couvertureUnit: string;
    description: string;
    exempleTitre: string;
    exempleColor: string;
    exempleInfo: string;
    exempleDescription: string;
    exempleCoutTotal: number;
    exemplePartSecu: number;
    exemplePartMgp: number;
    exemplePartAdherent: number;
    exemplePrecision?: string;
    
}

export interface IGarantiePrices {
    conjointPrice: number;
    childLess21Price: number;
    childPlus21Price: number;
    options: IOptionPrices[];
}


export interface IOptionPrices {
    code: string;
    mpPrice: number;
    conjointPrice: number;
    childLess21Price: number;
    childPlus21Price: number;
}

export enum IdentityType {
    PASSPORT = 'PASSPORT',
    CNI = "CNI",
    // CST = "CST"
    CST= 'RESIDENCE_PERMIT'
}

export interface IGuaranty {
    hasPartner: boolean;
    childrenBirthDates: string[] | undefined;
}

export interface IPerson {
    birthDate: string,
    regimeType: string
}

export interface ISimulateOffers {
    garanteeType: string,
    coverageType: string,
    effectiveDate: string,
    hasPartner: boolean,
    partner: IPerson,
    hasChild: boolean,
    children: IPerson[],
    regimeType: string,
    simulationProcessType: string,
    salaryAmount: number
}

export interface IRequestDataOffers {
    principalMemberInfo: {
      retiredDate: string;
      birthDate: string;
      hasAlsaceMoselle: true
    },
    partnerInfo: IPartnerDetail | null,
    childrenInfo: IChildDetail[],
    effectiveDate: string;
    coveragesInfo: ICoveragesInfo
  }

  export interface IRERequestDataOffers {
    principalMemberInfo: {
      retiredDate: string;
      birthDate: string;
      hasAlsaceMoselle: true
    },
    partnerInfo: IPartnerDetail | null,
    childrenInfo: IChildDetail[],
    effectiveDate: string;
    coveragesInfo: IRECoveragesInfo
  }

export interface IOptionCotisation {
    offerCode: string;
    totalPrice: number;
    recommended: boolean
}

export interface IOffers {
    offers: IOptionCotisation[];
}

export interface IPersonOffers {
    relationType: string,
    birthDate: string,
    basePrice: number,
    optionPrice: number,
    totalPrice: number,
    fomula: string
}

export interface IOffersDetails {
    garanteeType: string,
    coverageType: string,
    optionType: string,
    agentFinalTotalPrice: number,
    employeeBasePartPrice: number,
    employeeOptionPartPrice: number,
    agent: IPersonOffers,
    partner: IPersonOffers,
    children: IPersonOffers[],
    youngChildTotalPrice: number,
    adultChildTotalPrice: number,
    reducedAmountOnPayslip: number,
    debitedAmountFromBankAccount: number
}

export interface IRequestDataCreateRetirementProposition { 
    effectiveDate: string,
    contact: {
        birthDate: string,
        email: string,
        civilityCode: number,
        birthName: string,
        birthPlace: string,
        familySituationCode: number,
        nir: string,
        nirKey: string,
        regimeCode: number | null,
        address: string,
        additionalAddress: string,
        buildingName: string,
        lieudit: string
        city: string,
        postalCode: string,
        countryId: string,
        hiringDate: string,
        phoneNumber: string,
        cspIndex: number | null,
        companyGrade: string,
        companyIndex: string,
        firstName: string,
        lastName: string,
        retiredDate: string,
    },
    offerCode: string
      
}

export enum regimeType {
    GENERAL = 'GENERAL',
    ALSACE_MOSELLE = "ALSACE_MOSELLE"
}

export enum garanteeType {
    MIOM_BASE = 'MIOM_BASE',
}

export enum simulationProcessType {
    SIMULATION = 'SIMULATION',
}

export enum environementValues {
    PROD = 'prod',
    RECETTE = 'rct',
    LOCAL = 'local'
}

export interface ISubscriptionInfo {
    birthDate: string,
    nir: string,
    nirKey: string,
    administrativeNumber: string
}

export interface ISubscriptionInfoV2 {
    birthDate: string,
    numberSecurity: string,
    administrativeNumber: string
}


export interface ISubscriptionAccessCode {
    email: string,

}

export interface ISubscriptionConfirmEmailCode {
    accessCode: string
}

export interface ISubscriptionSendLinkData {
    email: string,
}

export interface ISubscriptionSendLinkCreateAccountData {
    email: string,
    phoneNumber: string
}

export interface ISubscriptionHandleChangeStep {
    token?: string, 
    isShowPhoneNumber?: boolean, 
    subscriptionUrl?: string,
    cacheId?: string
}

export  enum MemberStatusType {
    NOT_FOUND  = 1,
    FOUND_NO_AFFILIATION = 2,
    AFFILIATED_WITH_ACCOUNT = 3,
    AFFILIATED_WITHOUT_ACCOUNT = 4,
    PROPOSITION_PENDING = 5,
    PROPOSITION_AFFILIATION_OFFICE = 6,
    PAPER_FORMULA = 7,
    WAITING_VALIDATION = 8
}
